import axios from "axios";
import {container, useConfig, useRouter, useUserStore} from "@/plugins/obscore";
import {ref} from "vue";

let config;
let baseApiHost;

function getUrl(url) {
    if (!baseApiHost) {
        config = useConfig()
        baseApiHost = config.model.baseApiHost
    }
    return baseApiHost + url
}

export async function getRequest(baseURL, config, isPublic, isAbsolute) {
    config = handleRequest(config, isPublic)
    if (!isAbsolute) {
        baseURL = getUrl(baseURL)
    }
    return axios
        .get(baseURL, config)
        .then(data => {
            return data
        })
        .catch(err => {
            handleError(err)
        })
}

export async function postRequest(baseURL, params, config, isPublic, isAbsolute) {
    config = handleRequest(config, isPublic)
    if (!isAbsolute) {
        baseURL = getUrl(baseURL)
    }
    return axios
        .post(baseURL, params, config)
        .catch(err => {
            handleError(err)
        })
}

export async function putRequest(baseURL, params, config, isPublic, isAbsolute) {
    config = handleRequest(config, isPublic)
    if (!isAbsolute) {
        baseURL = getUrl(baseURL)
    }
    return axios
        .put(baseURL, params, config)
        .catch(err => {
            handleError(err)
        })
}

export async function deleteRequest(baseURL, config, isPublic, isAbsolute) {
    config = handleRequest(config, isPublic)
    if (!isAbsolute) {
        baseURL = getUrl(baseURL)
    }
    return axios
        .delete(baseURL, config)
        .catch(err => {
            handleError(err)
        })
}

function handleError(err) {
    console.log(err)
    if (err.response.status === 401 || (err.response.status === 403 && err.response.data.message === "An authentication exception occurred.")) {
        useUserStore().logout()
        useRouter().push({name: "login"});
    }
    Object.assign(container.error, err.response)
    throw err
}

function handleRequest(config, isPublic) {
    container.error = ref({})
    return useUserStore().prepareRequest(config, isPublic)
}